import { useContext, useMemo } from "react";
import { AuthContext } from "../context/authcontext";

const SALES_USER_ROLE = "SALESUSER";

const normalizeRole = (role: unknown) => String(role ?? "").toUpperCase().replace(/[\s_]/g, "");

export const isSalesUserRole = (auth: any, tenantId: string | number | null | undefined): boolean => {
  if (!auth || tenantId === null || tenantId === undefined || tenantId === "") return false;
  const tenant = Array.isArray(auth.tenants)
    ? auth.tenants.find((item: any) => String(item?.tenant_id) === String(tenantId))
    : null;
  return normalizeRole(tenant?.role_key || tenant?.role_name) === SALES_USER_ROLE;
};

export const resolveSalesUserId = (auth: any, tenantId: string | number | null | undefined): number | null => {
  if (!isSalesUserRole(auth, tenantId)) return null;
  const userId = Number(auth.user_id ?? auth.id);
  return Number.isFinite(userId) && userId > 0 ? userId : null;
};

export const useIsSalesUser = (): boolean => {
  const { auth, selectedTenantId } = useContext(AuthContext);
  return useMemo(() => isSalesUserRole(auth, selectedTenantId), [auth, selectedTenantId]);
};

export const useSalesUserId = (): number | null => {
  const { auth, selectedTenantId } = useContext(AuthContext);
  return useMemo(() => resolveSalesUserId(auth, selectedTenantId), [auth, selectedTenantId]);
};
